import Stack from 'atoms/Layout/Stack/Stack';
import PricingCardsWithSelection from 'molecules/PricingCardsWithSelection/PricingCardsWithSelection';
import React from 'react';
import PricingQuizModal from 'src/app_previous/organisms/Standard/Pricing/PricingQuizModal/PricingQuizModal';
import { IPricingCard } from 'src/hooks/usePricingCards';
import usePricingQuizModalController from 'src/hooks/usePricingQuizModalController';

interface PricingCardsWithQuizProps {
  pricingItems: IPricingCard[];
  activePriceMode: 'monthly' | 'annual';
  setActivePriceMode: (activePriceMode: 'monthly' | 'annual') => void;
}

const PricingCardsWithQuiz = ({
  pricingItems,
  activePriceMode,
  setActivePriceMode,
}: PricingCardsWithQuizProps): JSX.Element => {
  const { displayPricingQuiz, quizIsOpen, skipIntro } = usePricingQuizModalController(false);

  const tabs = [
    {
      label: 'Monthly billing',
      onClick: () => setActivePriceMode('monthly'),
      isSelected: activePriceMode === 'monthly',
    },
    {
      label: 'Annual billing',
      badge: 'Save 20%',
      onClick: () => setActivePriceMode('annual'),
      isSelected: activePriceMode === 'annual',
    },
  ];

  return (
    <Stack
      padding={['spacing-none', 'spacing-4xl']}
      paddingXl={['spacing-none', 'spacing-xl']}
      margin={['spacing-none', 'spacing-auto']}
    >
      <PricingCardsWithSelection
        tabs={tabs}
        pricingCards={pricingItems}
        pricingQuiz={{
          text: {
            type: 'paragraph',
            size: 'xl',
            fontWeight: 'font-weight-semibold',
            text: 'Which plan is right for you?',
          },
          onClick: displayPricingQuiz(true),
        }}
      />
      {/* TODO (MKT-9357): Migrate the BaseModal to the new app folder and then migrate the PricingQuizModal to the new app folder */}
      <PricingQuizModal
        isVisible={quizIsOpen}
        closeQuiz={displayPricingQuiz(false)}
        skipIntro={skipIntro}
      />
    </Stack>
  );
};

export default PricingCardsWithQuiz;
